import NoodlViewerReact from './noodl-viewer-react';

window.Noodl._viewerReact = NoodlViewerReact;
